<template>
  <div class="column">
    <div class="card-container">
      <div class="card">
        <div class="card-image">
          <figure class="image is-4by5">
            <img :src="image" alt="Placeholder image">
          </figure>
        </div>
        <div class="card-content">
          <p class="title is-4">{{ name }}</p>
          <p class="subtitle is-6">
            <router-link
              :to="{name: 'User', params: { username: username }}">
              @{{ username }}
            </router-link>
          </p>
          <div class="content">
            {{ description }}
            <br>
            <a :href="website">Contact</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
      type: String
    },
    image: {
      required: true,
      type: String
    },
    username: {
      required: true,
      type: String
    },
    description: {
      required: true,
      type: String
    },
    website: {
      required: false,
      type: String
    }
  }
}
</script>

<style scoped>
  .card-container {
    width: 320px;
  }
  .subtitle a {
    padding: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/AboutCard.vue